import makeStyles from '@mui/styles/makeStyles';
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ApplicationBar, { toolbarHeight } from "../../Components/ApplicationBar";

import ProcessBar from "../../Components/ProcessBar";
import Footer from "../../Components/Footer";
import { Button } from "@mui/material";

import { siteMap, getPrev, getNext } from "../../siteMap/index";
import { useLocation} from "react-router";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import service from "../../Helpers/gifservices";
import { resetForm } from "../../../../store/formSlice";
import { useAlert } from "../../../../Contexts/AlertContext/AlertService";
import { canEditSelector, refereeSelector } from "../../../../store/refereeSlice";
import { useCallback, useEffect, useState } from "react";
import { MAIN_PAGE_URL } from "../../Constants";
import { useNotify } from "../../../../providers/NotificationProvider";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
    marginTop: toolbarHeight,
    marginBottom: toolbarHeight,
    height: `calc(100vh - ${toolbarHeight * 2}px)`,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  mainPaper: {
    padding: theme.spacing(2),
    display: "flex",
    height: `calc(100vh - ${toolbarHeight * 2 + 190}px)`,
    overflow: "auto",
    flexDirection: "column",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  actionsWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  actionButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
}));


export default function ProgressLayout({ children, navigation, baseurl }) {
  const classes = useStyles();
  const localtion = useLocation();
  const history = useHistory();
  const notify = useNotify();
  const dispatch = useDispatch();
  const alert = useAlert();
  const referee = useSelector(refereeSelector);
  const canEdit= useSelector(canEditSelector);
  const currentForm = useSelector((state) => state.currentForm);
  const [refereeCheck, setRefereeCheck] = useState(false)

  const checkRefereeExist=useCallback(async()=>{
    if(!refereeCheck){
      setRefereeCheck(true);
    if(!referee){
    await alert({
      title: "Error loading the proposal",
      description: `error loading the proposal - probably because the proposal has already been send to evaluation`,
    });
    history.push(MAIN_PAGE_URL);
  }
  }
  },[referee, alert, history, refereeCheck])

  useEffect(() => {
    checkRefereeExist();
  }, [checkRefereeExist]);

  const submitCurrentForm = async () => {
    const formData = currentForm.data.payload;
    const func = currentForm.serviceFunction.payload;
    if (func == null) return;
    if (formData == null) return;

    if (!service[func])
      // this is set by setServiceFunction inside a form page.
      throw new Error(`gif services dosent have a function called ${func}`);

    await service[func](formData);
    dispatch(resetForm());
  };

  const handleBack = async () => {
    const relativePath = localtion.pathname.replace(baseurl, "");
    const route = getPrev(relativePath);
    await submitCurrentForm();
    if (route) {
      history.push(`${baseurl}${route}`);
    }
  };
  const handleNext = async () => {
    const relativePath = localtion.pathname.replace(baseurl, "");
    const route = getNext(relativePath);
    await submitCurrentForm();
    if (route) {
      history.push(`${baseurl}${route}`);
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <ApplicationBar showProposalInfo showDashboardButton/>
      <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ProcessBar
                procceses={siteMap.filter((sm) => sm.progress === true)}
                baseurl={baseurl}
              />
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.mainPaper} style={{}}>
                {children}
              </Paper>
            </Grid>
          </Grid>
          <Box pt={2} className={classes.actionsWrapper}>
            <Button
              variant="contained"
              className={classes.actionButton}
              disableElevation
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              variant="contained"
              className={classes.actionButton}
              disableElevation
              disabled={!canEdit}
              onClick={()=>{
                notify.show("Saving..");
                submitCurrentForm();
              }}
            >
              Save
            </Button>
            <Button
              variant="contained"
              className={classes.actionButton}
              disableElevation
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
